export default __webpack_public_path__ + "static/media/Inter-UI-ExtraBoldItalic.79f3c9d8.woff";